import React from "react";

export const Button = ({
  children,
  as = "button",
  className: _class,
  type = "primary",
  ...rest
}) => {
  const className = `px-4 py-3 rounded text-sm ${
    type === "primary"
      ? "bg-blue text-white shadow-md"
      : "bg-white text-blue border-blue border"
  } ${_class}`;

  return React.createElement(as, { className, ...rest }, children);
};
